import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";

import authReducer from "@store/features/auth";
import categoriesReducer from "@store/features/categories";
import commentsReducer from "@store/features/comments";
import contractsReducer from "@store/features/contracts";
import { createReduxEnhancer } from "@sentry/react";
import customersReducer from "@store/features/customers";
import groupReducer from "@store/features/group";
import groupsReducer from "@store/features/groups";
import layoutManagerReducer from "@store/features/layout-manager";
import permissionsReducer from "@store/features/permissions";
import referralsReducer from "@store/features/referrals";
import taskReducer from "@store/features/task";
import ticketReducer from "@store/features/ticket";
import ticketsReducer from "@store/features/tickets";
import userReducer from "@store/features/user";
import usersReducer from "@store/features/users";

const sentryReduxEnhancer = createReduxEnhancer();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    categories: categoriesReducer,
    comments: commentsReducer,
    contracts: contractsReducer,
    customers: customersReducer,
    group: groupReducer,
    groups: groupsReducer,
    layoutManager: layoutManagerReducer,
    permissions: permissionsReducer,
    referrals: referralsReducer,
    task: taskReducer,
    ticket: ticketReducer,
    tickets: ticketsReducer,
    user: userReducer,
    users: usersReducer,
  },
  enhancers: [sentryReduxEnhancer],
});

export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
